import React from 'react';

const MonthlyDetailedHitsUsage = ({ data }) => {
  return (
    <table className="table table-hover table-stripped">
      <thead>
        <tr>
          <td>
            <strong>
              Hits/Mes
            </strong>
          </td>
          { data.map((item) => (
              <td key={ `header_${item.month}` } className="text-center">{ item.month }</td>
            ))
          }
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Timbrado</td>
            { data.map((item) => (
                <td key={ `stamping_${item.month}` } className="text-center">{ item.stamping }</td>
              ))
            }
        </tr>
        <tr>
          <td>Cancelaciones</td>
            { data.map((item) => (
                <td key={ `cancellations_${item.month}` } className="text-center">{ item.cancellations }</td>
              ))
            }
        </tr>
      </tbody>
    </table>
  );
}

export default MonthlyDetailedHitsUsage;